import { create } from 'zustand';

interface IStore {
  _id: string;
  name: string;
  assets: any;
  clients: any;
  archived: boolean;
  totalItems: number;
}

interface IAssets {
  _id: string,
  plantName: string
}

interface StoreState {
  storesData: IStore[];
  setStoresData: (storesData: IStore[]) => void;
  selectedStoreAssets: IAssets[];
  setSelectedStoreAssets: (selectedStoreAssets: IAssets[]) => void;
  storeName: string;
  setStoreName: (storeName: string) => void;
  setSelectedStoreTab: (selectedStoreTab: { _id: string; name: string }) => void;
  selectedStoreTab: { _id: string; name: string };
  selectedAssetTab: { _id: string; name: string };
  setSelectedAssetTab: (selectedAssetTab: { _id: string; name: string }) => void;
  assetName: string;
  setAssetName: (assetName: string) => void;
}

type StoreTabsData = Pick<StoreState, 'storesData' | 'selectedStoreAssets' | 'storeName' | 'selectedStoreTab' | 'selectedAssetTab' | 'assetName'>;

const initialStoreTabs = (): StoreTabsData => ({
  storesData: [],
  selectedStoreAssets: [],
  storeName: 'All Store',
  selectedStoreTab: { _id: '', name: '' },
  selectedAssetTab: { _id: '', name: '' },
  assetName: 'All Asset',
});

export const useTabs = create<StoreState>((set) => ({
  ...initialStoreTabs(),
  setStoresData: (storesData) => set({ storesData }),
  setSelectedStoreAssets: (selectedStoreAssets) => set({ selectedStoreAssets }),
  setStoreName: (storeName) => set({ storeName }),
  setSelectedStoreTab: (selectedStoreTab) => set({ selectedStoreTab }),
  setSelectedAssetTab: (selectedAssetTab) => set({ selectedAssetTab }),
  setAssetName: (assetName) => set({ assetName }),
}));

/** The stores and the selection held for the person who left: the next person starts from all stores. */
export const resetStoreTabs = (): void => useTabs.setState(initialStoreTabs());